import { useEntity } from '@backstage/plugin-catalog-react';
import { Card, CardBody, Link, Text } from '@backstage/ui';
import { useState } from 'react';

import { isApiEntityMcpServer } from './isApiEntityMcpServer';
import { McpTool } from './mcpTypes';
import { parseStaticTools } from './parseStaticTools';
import { ToolRow } from './ToolRow';

const TOOLS_DOCS_URL = '/docs/default/system/varia/users/#mcp-servers';

const ToolsList = ({ tools }: { tools: McpTool[] | undefined }) => {
  if (!tools || tools.length === 0) {
    return (
      <Text>
        No tools list available. To provide one, please check{' '}
        <Link href={TOOLS_DOCS_URL}>the documentation</Link>.
      </Text>
    );
  }
  return (
    <>
      {tools.map(tool => (
        <ToolRow key={tool.name} tool={tool} />
      ))}
    </>
  );
};

export const McpServerToolsCard = () => {
  const { entity } = useEntity();
  const [tools] = useState(() => parseStaticTools(entity.spec?.definition));

  if (!isApiEntityMcpServer(entity)) {
    return null;
  }

  return (
    <Card>
      <CardBody>
        <ToolsList tools={tools} />
      </CardBody>
    </Card>
  );
};
